/**
 * Created by rjablonowski on 6/7/2019.
 */
export class Order {
  id: number;
  status: number;
  partner_id: number;
  partner_name: string;
  customer_name: string;
  contact_name: string;
  contact_email: string;
  contact_phone: string;
  extension_limit: number;
  subscription_months: number;
  notes: string;
}

export class Partner {
  id: number;
  name: string;
  contact_name: string;
  contact_email: string;
  contact_phone: string;
  skyswitch_reseller: SkyswitchReseller;
}

export class SkyswitchReseller {
  reseller_id: string;
  api_username: string;
  api_password: string;
  api_client_id: string;
  api_client_secret: string;
}

export class Customer {
  id: number;
  partner_id: number;
  partner_name: string;
  name: string;
  contact_name: string;
  contact_email: string;
  contact_phone: string;
  options: CustomerOptions;
}

export class CustomerOptions {
  available_partners: DisplayValue[];
}

export class Subscription {
  id: number;
  customer_id: number;
  partner_id: number;
  partner_name: string;
  clsw_site_id: number;
  clsw_site_name: string;
  customer_name: string;
  available_sites: DisplayValue[];
  start_date: Date;
  end_date: Date;
  extension_limit: number;
}

export class User {
  id: number;
  partner_id: number;
  role_id: number;
  username: string;
  password: string;
  options: UserOptions;
}

export class UserOptions {
  available_partners: DisplayValue[];
}

export class DisplayValue {
  display: string;
  value: number;
}



// WEBPACK FOOTER //
// ./src/app/app-models/models.ts